import {ChangeDetectorRef, Component} from '@angular/core';
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../../dip/dip-column";
import {HelpService} from "../../../services/help.service";
import {HelpForm} from "../help-form/help-form";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-help-grid',
  templateUrl: './help-grid.html'
})
export class HelpGrid extends AbstractProdGrid implements IProdGrid {
  prodGridTitle: string = this.translate.instant('help.grid_title')
  isAddButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_SYS]);
  isAddButtonShown: boolean = this.roleService.hasRole([Role.ROLE_SYS]);
  override prodGridForm = {component: HelpForm};
  prodGridColumns: DipColumn[] = [
    DipColumn.get({property: 'id', type: ProdGridColumnType.ID}),
    DipColumn.get({
      property: 'filePath',
      type: ProdGridColumnType.DOWNLOAD,
      transform: {
        transform: ProdGridColumnTransforms.DOWNLOAD_ICON
      }
    }),
    DipColumn.get({property: 'name', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'language', type: ProdGridColumnType.STRING})
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: HelpService,
              private roleService: RoleService,
              private translate: TranslateService) {
    super(changeDetectorRef);
  }
}
